<template>
  <div>
    <PageTitle title="Sales Return" />

    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="show">
          <TableFilters
            :filters="[
              'customer',
              'search',
              'biller',
              'dateRange',
              'product',
              'shop',
            ]"
            v-model="filter"
            :columns="columns"
            paginationOptions
          ></TableFilters>
        </v-card>
      </v-expand-transition>
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :headers="headers"
                :items="salesReturnList"
                @click:row="$router.push(`sales-return/views/${$event.id}`)"
                item-key="name"
                hide-default-footer
                class="row-pointer"
                style="font-family: 'Source Sans Pro', sans-serif"
              >
                <template v-slot:no-data>
                  <noData
                    class="mt-16 container justify-center item-center"
                    name="sales return"
                  />
                </template>

                <template v-slot:item.reference_number="{ item }">
                  <div>
                    {{
                      item.reference_number
                        ? item.reference_number
                        : '---------'
                    }}
                  </div>
                </template>

                <template v-slot:item.date="{ item }">
                  <div>
                    {{ item.date ? item.date : '---------' | formatDate }}
                  </div>
                </template>
                <template v-slot:item.first_name="{ item }">
                  <div>
                    {{ item.first_name ? item.first_name : '---------' }}
                  </div>
                </template>
                <template v-slot:item.shop.name="{ item }">
                  <div>
                    {{
                      ShopView == 'name' ? item.shop.sortform : item.shop.name
                    }}
                  </div>
                </template>
                <template v-slot:item.biller.first_name="{ item }">
                  <div>
                    {{
                      item.biller.first_name
                        ? item.biller.first_name
                        : '---------'
                    }}
                  </div>
                </template>
                <template v-slot:item.customer.name="{ item }">
                  <div>
                    {{ item.customer.name ? item.customer.name : '---------' }}
                  </div>
                </template>
                <template v-slot:item.total="{ item }">
                  <div>
                    {{ item.total ? item.total : '---------' | formatCurrency }}
                  </div>
                </template>
                <template v-slot:item.status="{ item }">
                  <div class="d-flex flex-row">
                    <v-chip
                      :x-small="true"
                      class="ma-1 w-100"
                      label
                      text-color="white"
                      :color="getStatusColor(item.status)"
                      dark
                      style="
                        color: white;
                        font-variant-caps: all-small-caps;
                        font-weight: bold;
                      "
                      >{{ item.status ? item.status : '---------' }}</v-chip
                    >
                  </div>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-menu offset-y transition="scroll-y-transition">
                    <template v-slot:activator="{ $attrs, on }">
                      <v-icon v-bind="$attrs" v-on="on"
                        >mdi-dots-vertical</v-icon
                      >
                    </template>
                    <v-list class="actions">
                      <permission-control permissionName="Sales Show">
                        <v-list-item
                          @click="$router.push('sales-return/views/' + item.id)"
                          link
                        >
                          <span>
                            <v-icon v-bind="$attrs" v-on="on">mdi-eye</v-icon
                            >View
                          </span>
                        </v-list-item>
                      </permission-control>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:footer>
                  <pagination
                    @responseData="setResponseData"
                    @paginationOptions="setPaginationOptions"
                    :filterAction="true"
                    url="sales-return"
                    :filter="filter"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import pagination from '../../modules/shared/components/pagination.vue';
import confirmation from '../../modules/shared/components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import { mapState } from 'vuex';
import noData from '../../components/shared/noItem';

export default {
  components: {
    TableFilters,
    pagination,
    noData,
  },
  data() {
    return {
      on: {
        click: console.log,
        contextmenu: console.log,
      },
      show: false,
      singleExpand: false,
      paginationOptions: {},
      isLoading: true,
      total: 0,
      grandTotal: 0,
      discountTotal: 0,
      columns: [
        {
          text: 'Date',
          value: 'date',
          show: true,
          disabled: false,
          width: '12.5%',
          align: 'center',
          sortable: 'false',
        },
        {
          text: 'Reference Number',
          value: 'reference_number',
          show: true,
          disabled: false,
          width: '12.5%',
          align: 'center',
          sortable: 'false',
        },
        {
          text: 'Shop',
          value: 'shop.name',
          show: true,
          disabled: false,
          align: 'center',
          width: '12.5%',
          sortable: false,
        },
        {
          text: 'Biller',
          value: 'biller.first_name',
          show: true,
          disabled: false,
          align: 'center',
          width: '12.5%',
          sortable: false,
        },
        {
          text: 'Customer',
          value: 'customer.name',
          show: true,
          disabled: false,
          align: 'center',
          width: '12.5%',
          sortable: false,
        },

        {
          text: 'Total',
          value: 'total',
          show: true,
          disabled: false,
          width: '12.5%',
          align: 'center',
          sortable: 'false',
        },

        {
          text: 'Status',
          value: 'status',
          show: true,
          disabled: false,
          width: '12.5%',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          show: true,
          disabled: false,
          width: '12.5%',
          align: 'center',
          sortable: 'false',
        },
      ],
      salesReturnList: [],
      filter: {
        name: '',
        customer: '',
        start: '',
        end: '',
        shop: '',

        search: '',
        status: '',
      },
      products: [],
    };
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;

        case 'Partially Paid':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;

        default:
          break;
      }
    },
    // setPagenumber(event) {
    //   this.$router.push("?page=" + event);
    //   this.$store.dispatch("SetProductSize", event);
    // },

    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },

    setResponseData(salesreturn) {
      this.salesReturnList = salesreturn;
    },
  },
  computed: {
    ...mapState(['ShopView']),
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    //this.GetSuppliers();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.deuamount {
  color: brown;
  font-weight: bold;
}

.w-100 {
  width: 90px;
  font-weight: 900;
}

.p-100 {
  font-weight: bold;
}

.b-100 {
  font-weight: bold;
  text-align: right;
}
.f-100 {
  font-weight: 900;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}

.min-button::before {
  display: none;
}
</style>
